// Recap fetch-time estimates (display only).
//
// Empirically derived from a real Yahoo run (2026-07-20): 20 seasons took
// 15m39s = ~47s/season, dominated by ~7 rate-limited endpoints/season at
// Yahoo's ~1.1s throttle plus typical 429 backoff. The old ~25s/season
// (0.4 min) estimate ignored backoff and read as "broken" when reality ran
// ~2x longer. We round UP and present a range: finishing early reads as fast;
// the reverse reads as broken.
export const EST_SEC_PER_SEASON = 47;

// Upfront "roughly LOW–HIGH minutes" range for a season count. Rounded up; the
// high end carries ~25% headroom for backoff clusters. null for < 1 season.
export function upfrontEstimateMinutes(seasonCount) {
  const n = Number(seasonCount) || 0;
  if (n < 1) return null;
  const totalSec = n * EST_SEC_PER_SEASON;
  const low = Math.max(1, Math.round(totalSec / 60));
  const high = Math.max(low + 1, Math.ceil((totalSec * 1.25) / 60));
  return { low, high };
}

// Live rolling ETA in seconds = observed avg sec/season × seasons remaining.
// Rate-limit stalls are absorbed automatically (they inflate the observed
// average), so no special-casing. Returns null until ≥2 seasons of progress
// have completed (enough signal to average), or when inputs are degenerate.
export function rollingEtaSec(elapsedSec, seasonsDone, seasonsTotal) {
  const e = Number(elapsedSec), d = Number(seasonsDone), tot = Number(seasonsTotal);
  if (!(e > 0) || !(d >= 2) || !(tot > d)) return null;
  const avgPerSeason = e / d;
  return Math.round(avgPerSeason * (tot - d));
}

// "~N min remaining" / "<1 min remaining". null-safe.
export function fmtRemaining(etaSec) {
  if (etaSec == null || !(etaSec >= 0)) return null;
  if (etaSec < 60) return "<1 min remaining";
  return `~${Math.round(etaSec / 60)} min remaining`;
}
